// extracted by mini-css-extract-plugin
export default {"wrapper":"contentBox_wrapper__LENNJ","pad-none":"contentBox_pad-none__zQjvP","pad-s":"contentBox_pad-s__2YOU8","pad-m":"contentBox_pad-m__XGsjC","pad-l":"contentBox_pad-l__Bcrpd"};